import { AgentSkill, Skills } from "@nice-ccf/common-sdk";
import { HttpResponse } from "@nice-ccf/core-sdk";

/**
 * This class to parse api response
 */
export class SkillApiParser {
    /**
     * Method to parse agent permissions response
     * 
     * @param permissions - permissions response
     * @returns - parsed permissions
     * @example - 
     * ```
     * parsePermissions(permissions)
     * ```
     */
    public parseAgentSkills(response: HttpResponse): AgentSkill[] {
        const agentSkillAssignments = response.data.agentSkillAssignments;
        const agentSkillLists: AgentSkill[] = [];
        for (let i = 0; i < agentSkillAssignments.length; i++) {
            const respObj = agentSkillAssignments[i];
            if (respObj.isActive && !respObj.isRestricted) {
                const data = {
                    isOutbound: respObj.isOutbound,
                    strategy: respObj.outboundStrategy,
                    typeId: respObj.mediaTypeId,
                    skillId: respObj.skillId,
                    skillName: respObj.skillName,
                    isNaturalCallingRunning: respObj.isNaturalCallingRunning,
                    isPriorityBlending: respObj.priorityBlending,
                    useACW: respObj.useACW
                }
                agentSkillLists.push(data);
            }
        }
        return agentSkillLists;
    }

    /**
     * Method to parse permissions response
     * 
     * @param permissions - permissions response
     * @returns - parsed permissions
     * @example - 
     * ```
     * parsePermissions(permissions)
     * ```
     */
    public parseAllSkillsList(response: HttpResponse): Skills[] {
        const allSkillAssignments = response.data.skills;
        const allSkillLists: Skills[] = [];
        for (let i = 0; i < allSkillAssignments.length; i++) {
            const respObj = allSkillAssignments[i];
            if (respObj.isActive && !respObj.isRestricted) {
                const data = {
                    skillId: respObj.skillId,
                    skillName: respObj.skillName,
                    mediaTypeId:respObj.mediaTypeId,
                    mediaTypeName:respObj.mediaTypeName,
                    isActive:respObj.isActive,
                    isOutbound: respObj.isOutbound,
                }
                allSkillLists.push(data);
            }
        }
        return allSkillLists;
    }
}
